import styled from 'styled-components';
import { htmlId } from 'utils/html';

const Animation = styled.div`
  transition: opacity 0.5s;

  &.visible {
    opacity: 1;
  }

  &.hidden {
    opacity: 0;
  }
`;
const FadeOut = (props: any) => {
  return (
    <Animation id={htmlId('transition-fade-out')} className={props.out ? 'hidden' : 'visible'}>
      {props.children}
    </Animation>
  );
};

export default FadeOut;
